import { render, staticRenderFns } from "./ProductListToolbarPaginator.vue?vue&type=template&id=e3078152"
import script from "./ProductListToolbarPaginator.vue?vue&type=script&lang=ts"
export * from "./ProductListToolbarPaginator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports